import '../../../styles/index.css'
import './Footer.css';
import { useNavigate } from 'react-router-dom';

function Footer() {

  const navigate = useNavigate();

  return (
    <footer className='footer'>

      <div className='footer-container page-container'>

        <h5 className='tituloFooter logo'>OnPrice</h5>

        <ul className='footer__lista'>

          <li className='footer__lista__item' onClick={() => navigate('/')}>
            <p className="bt2 link">Home</p>
          </li>

          <li className='footer__lista__item' onClick={() => navigate('/Montagem')}>
            <p className="bt2 link">Monte seu PC</p>
          </li>

          <li className='footer__lista__item' onClick={() => navigate('/SobreNos')}>
            <p className="bt2 link">Sobre Nós</p>
          </li>

        </ul>

      </div>

    </footer>
  );
}

export default Footer;
